import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=04d3fb5c&scoped=true&"
import script from "./SettingsPanel.vue?vue&type=script&lang=js&"
export * from "./SettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPanel.vue?vue&type=style&index=0&id=04d3fb5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d3fb5c",
  null
  
)

export default component.exports